<template>
  <div>
    <section class="section--actions-page bg-transparent mb-0 pt-4 pb-1">


      <!-- EXTERNAL COMPONENT -->
      <component :if="componentName" :is="componentName" />

      <!-- SEARCH BAR -->
      <div class="filter-bar-table" v-if="vtbl_show_search">
        <filter-bar ref="filterBar" :filter_fields="this.getFilterFields()" @vuetable-filterBar:doFilter="onDoFilter"
          @vuetable-filterBar:resetFilter="onResetFilter">
        </filter-bar>
      </div>


      <div class="hrt-actions">

        <!-- FILTER APPLICANTS -->
        <div class="hrt-dropdown dropdown" v-if="applicant_filters">
          <button class="btn dropdown-toggle" type="button" id="dropdownMenuButtonVueTableFilters" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <span v-if="!activeStatusApplicant">Filtra per status</span>
            <span v-else>
              <span v-if="activeStatusApplicant == 1">{{ __('forms.RecruitingApplicantStatus.status.positive') }}</span>
              <span
                v-else-if="activeStatusApplicant == 2">{{ __('forms.RecruitingApplicantStatus.status.negative') }}</span>
              <span
                v-else-if="activeStatusApplicant == 3">{{ __('forms.RecruitingApplicantStatus.status.evaluating') }}</span>
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonVueTableFilters">
            <a :href="JSON.parse(applicant_filters)['remove']"
              class="dropdown-item">{{ __('forms.RecruitingApplicantStatus.remove') }}</a>
            <a :href="JSON.parse(applicant_filters)['positive']"
              class="dropdown-item">{{ __('forms.RecruitingApplicantStatus.status.positive') }}</a>
            <a :href="JSON.parse(applicant_filters)['negative']"
              class="dropdown-item">{{ __('forms.RecruitingApplicantStatus.status.negative') }}</a>
            <a :href="JSON.parse(applicant_filters)['evaluating']"
              class="dropdown-item">{{ __('forms.RecruitingApplicantStatus.status.evaluating') }}</a>
          </div>
        </div>

        <!-- FILTER ROLES -->
        <div class="hrt-dropdown dropdown" v-if="roles_filters">
          <button class="btn dropdown-toggle" type="button" id="dropdownMenuButtonVueTableFilters" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <span v-if="!activeStatusRole">Filtra per status</span>
            <span v-else>
              <span v-if="activeStatusRole == 1">{{ __('forms.RolePersonComparison.status.missing') }}</span>
              <span v-else-if="activeStatusRole == 2">{{ __('forms.RolePersonComparison.status.inactive') }}</span>
              <span v-else-if="activeStatusRole == 3">{{ __('forms.RolePersonComparison.status.expiring') }}</span>
              <span v-else-if="activeStatusRole == 4">{{ __('forms.RolePersonComparison.status.active') }}</span>
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonVueTableFilters">
            <a :href="JSON.parse(roles_filters)['remove']"
              class="dropdown-item">{{ __('forms.RolePersonComparison.remove_filter') }}</a>
            <a :href="JSON.parse(roles_filters)['missing']"
              class="dropdown-item">{{ __('forms.RolePersonComparison.status.missing') }}</a>
            <a :href="JSON.parse(roles_filters)['inactive']"
              class="dropdown-item">{{ __('forms.RolePersonComparison.status.inactive') }}</a>
            <a :href="JSON.parse(roles_filters)['expiring']"
              class="dropdown-item">{{ __('forms.RolePersonComparison.status.expiring') }}</a>
            <a :href="JSON.parse(roles_filters)['active']"
              class="dropdown-item">{{ __('forms.RolePersonComparison.status.active') }}</a>
          </div>
        </div>

        <!-- REPORT DROPDOWN -->
        <div class="hrt-dropdown dropdown" v-if="this.isVisibleDropDownReport">
          <button class="btn dropdown-toggle" type="button" id="dropdownMenuButtonVueTableReport" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            Report
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonVueTableReport">
            <a class="dropdown-item" v-if="this.exportxls_url" :href="this.exportxls_url"><i
                class="fal fa-arrow-alt-to-bottom"></i> Export XLS</a>
            <a class="dropdown-item" v-if="this.exportxls_organizational_units_url"
              :href="this.exportxls_organizational_units_url"><i class="fal fa-arrow-alt-to-bottom"></i> Export Persone
              UnitàOrg.</a>
            <a class="dropdown-item" v-if="this.make_zip_url" href="#" @click="makeZip(false)"><i
                class="far fa-file-archive"></i>{{ __("misc.make_zip") }}</a>
            <a class="dropdown-item" v-if="this.make_zip_url_async" href="#" @click="makeZip(true)"><i
                class="far fa-file-archive"></i> {{ __("misc.make_zip") }}</a>
            <span v-if="this.report_actions != null && this.report_actions.length > 0">
              <span v-for="(report_action, index) in this.report_actions" v-bind:key="index">
                <a class="dropdown-item" style="cursor: pointer"
                  v-if="report_action.visible == null || report_action.visible == true"
                  @click="executeBulkCustom(report_action)">
                  <i :class="report_action.icon"></i>{{ report_action.text }}</a>
              </span>
            </span>
          </div>
        </div>

        <!-- ACTION DROPDOWN -->
        <div class="hrt-dropdown dropdown" v-if="this.isVisibleDropDownActions">
          <button class="btn dropdown-toggle" type="button" id="dropdownMenuButtonVueTableAction" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            {{ __("misc.actions") }}
          </button>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonVueTableAction">
            <a class="dropdown-item" v-if="this.view_history_url" href="#" @click="viewHistoryLog()"><i
                class="fad fa-history"></i>{{ __("misc.viewHistoryLog") }}</a>
            <a class="dropdown-item" v-if="this.bulkedit_url" href="#" @click="bulkEdit()"><i
                class="fal fa-pen-square"></i>{{ __("misc.bulkEdit") }}</a>
            <a class="dropdown-item" v-if="this.bulkcreate_url" href="#" @click="bulkCreate()"><i
                class="fal fa-pen-square"></i>{{ __("misc.bulkCreate") }}</a>
            <a class="dropdown-item" v-if="this.bulkdelete_url" href="#" @click="bulkDelete()"><i
                class="fas fa-trash-alt side-icon"></i>{{ __("misc.bulkDelete") }}</a>
            <a class="dropdown-item" v-if="this.bulkarchive_url" href="#" @click="bulkArchive()"><i
                class="far fa-ballot-check"></i>Bulk Archivia</a>
            <a class="dropdown-item" v-if="this.sendmail_url" href="#" @click="sendEmail(3)"><i
                class="fal fa-mail-bulk"></i>{{ __("forms.WorkflowsStep.sendMail") }}</a>
            <a class="dropdown-item" v-if="this.send_massive_mail_url" href="#" @click="massiveEmail()"><i
                class="fal fa-mail-bulk"></i>{{ __("forms.People.sendMassiveMail") }}</a>
            <a class="dropdown-item" v-if="this.resetpassword_url" href="#" @click="sendEmail(2)"><i
                class="fal fa-lock"></i> {{ __("forms.People.new_password") }}</a>
            <a class="dropdown-item" v-if="this.massive_chage_permissions_url" href="#" @click="updatePermissions()"><i
                class="fal fa-lock"></i> Massive change permissions</a>
            <a class="dropdown-item" v-if="this.clone_models_url" href="#" @click="cloneElement()"><i
                class="fal fa-copy"></i>{{ __("misc.cloneElement") }}</a>
            <a class="dropdown-item" v-if="this.copy_models_url" href="#" @click="copyElement()"><i
                class="fal fa-copy"></i>{{ __("misc.copyElement") }}</a>
            <!-- Bulk custom - non mettere href="#" perchè sporca l'url-->
            <span v-if="this.bulk_custom_actions != null && this.bulk_custom_actions.length > 0">
              <span class="dropdown-item" v-for="(bulk_action, index) in this.bulk_custom_actions" v-bind:key="index"
                @click="executeBulkCustom(bulk_action)">
                <a style="cursor: pointer" v-if="bulk_action.visible == null || bulk_action.visible == true">
                  <i :class="bulk_action.icon"></i>{{ bulk_action.text }}
                </a>
              </span>
            </span>
          </div>
        </div>

        <!-- ADVANCED FILTERS -->
        <div class="table-rounded-buttons">
          <button data-toggle="tooltip" data-placement="top" title="Filtri Avanzati"
            class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history"
            v-if="has_advanced_filters" @click="openAdvancedFilters()">
            <i class="fa fa-filter"></i>
          </button>
        </div>

        <!-- CUSTOM COLUMNS -->
        <div class="table-rounded-buttons">
          <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history"
            v-if="this.columnsSelectorUrl !== undefined" href="#" @click="openCoulmnsSelector()" data-toggle="tooltip"
            data-placement="top" title="Imposta colonne opzionali">
            <i class="fa-solid fa-table-columns"></i>
          </button>
        </div>

      </div>



    </section>


    <!-- TABLE -->
    <div class="outer">

      <!-- ARROW -->
      <!-- <i @click="handleLeftScrollTable()" class="fal fa-angle-left prev-column"></i>
        <i @click="handleRightScrollTable()" class="fal fa-angle-right next-column"></i> -->

      <!-- TABLE CONTAINER -->
      <div class="newtable-container bg-white">
        <vuetable :detail-row-component="this.detail_row_component" @vuetable:cell-clicked="onCellClicked"
          ref="vuetable" class="fixed-columns scrollableForVuetable" :css="css.table" id="vue_table_component"
          :api-url="this.vtbl_url" :fields="this.vtbl_fields" :sort-order="this.vtbl_sort_order" :show-sort-icons="true"
          :track-by="this.vtbl_fields.id" :append-params="moreParams" :per-page="this.perPage" pagination-path=""
          @vuetable:loading="onLoading" @vuetable:load-success="onLoadSuccess"
          @vuetable:pagination-data="onPaginationData" @vuetable:checkbox-toggled="onCheckboxToggled"
          @vuetable:checkbox-toggled-all="onCheckboxToggledAll" >
          <!-- CUSTOM ACTION -->
          <template slot="actions" slot-scope="props">
            <div style="margin-left:-12px; margin-right:-10px;" class="d-inline-flex justify-content-around actions-cell p-0">

              <!-- PRINT ACTION -->
              <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history" type="button"
                v-if="hasButton('print')" @click="handleAction('print', props.rowData, props.rowIndex)">
                <i class="fas fa-print"></i>
              </button>


              <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history" type="button"
                v-if="hasButton('documents')" @click="handleAction('documents', props.rowData, props.rowIndex)">
                <i class="fas fa-file-alt"></i>
              </button>

              <!-- SHOW ACTION -->
              <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history" type="button"
                v-if="hasButton('show')" @click="handleAction('show', props.rowData, props.rowIndex)">
                <i class="fas fa-eye"></i>
              </button>

              <!-- GRAPH -->
              <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history" type="button"
                v-if="hasButton('graph')" @click="handleAction('graph', props.rowData, props.rowIndex)">
                <i class="fa fa-line-chart"></i>
              </button>

              <!-- EDIT -->
              <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit" type="button"
                v-if="hasButton('edit')" @click="handleAction('edit', props.rowData, props.rowIndex)"
                data-toggle="tooltip" data-placement="top" title="Edit">
                <i class="fas fa-pencil"></i>
              </button>

              <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove"
                type="button" v-if="hasButton('delete')" :disabled="props.rowData.is_disable_delete == true" @click="handleAction('delete', props.rowData, props.rowIndex)"
                data-toggle="tooltip" data-placement="top" title="Delete">
                <i class="fas fa-trash-alt"></i>
              </button>

              <button class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-history"
                type="button" v-if="hasButton('history')" @click="handleAction('history', props.rowData, props.rowIndex)"
                data-toggle="tooltip" data-placement="top" title="History">
                <i class="fa-solid fa-clock-rotate-left "></i>
              </button>

              <!-- Custom row actions -->
              <span v-if="isVisibleCustomRowActions()">
                <button v-for="(row_action, row_index) in getCustomRowActionsConfiguration(props.rowData)" v-bind:key="row_index" 
                  :class=row_action.class
                  type="button" @click="handleAction(row_action.name, props.rowData, props.rowIndex)"
                  data-toggle="tooltip" data-placement="top" :title=row_action.title>
                  <i :class=row_action.icon></i>
                </button>
              </span>
              
            </div>
          </template>
        </vuetable>
      </div>
    </div>

    <!-- Paginator -->
    <div v-if="this.vtbl_show_paginator" class="vuetable-pagination d-flex justify-content-between">
      <vuetable-pagination-info ref="paginationInfo" :info-template=paginationInfoResult></vuetable-pagination-info>

      <vuetable-pagination ref="pagination" v-on:vuetable-pagination:change-page="onChangePage"></vuetable-pagination>

      <div class="hrt-dropdown dropdown mt-3">
        <span class="pre-filter-label">{{ __("misc.per_page") }}</span>
        <button class="btn dropdown-toggle" type="button" id="dropdownPagination" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          {{ perPage }}
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownPagination">
          <a class="dropdown-item" href="#" @click="setPagination(10)">10</a>
          <a class="dropdown-item" href="#" @click="setPagination(20)">20</a>
          <a class="dropdown-item" href="#" @click="setPagination(50)">50</a>
          <a class="dropdown-item" href="#" @click="setPagination(100)">100</a>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import detailRow from "./vueTable/DetailRowSubTable.vue";

export default {
  components: {
    vuetable: Vuetable,
  },
  mounted() {
    this.componentName = this.component_filters_name;
    this.columnsSelectorUrl = this.vtbl_columns_selector;
    this.paginationInfoResult = this.__("misc.ResultFrom") + " " + "{from}" + " " + this.__("misc.ResultTo") + " " + "{to}" + " " + this.__("misc.ResultOf") + " " + "{total}";
    this.isVisibleDropDownReport = this.getVisibleDropDownReport();
    this.isVisibleDropDownActions = this.getVisibleDropDownActions();   
    window.addEventListener('reload-all-component', () => {            
      this.$refs.vuetable.refresh();
    }); 
  },
  data() {
    return {
      itemsSelected: [],
      moreParams: {},
      perPage: 20,
      renderedItems: [],
      tableHeight: "100px",
      componentName: "",
      columnsSelectorUrl: "",
      removeHeader: this.vtbl_remove_header,
      removePaginator: this.vtbl_remove_paginator,
      actualPage: 1,
      actualItemId: null,
      alreadyRefresh: false,
      fromGoToPage: false,
      paginationInfoResult: null,
      css: {
        table: {
          tableWrapper: '',
          tableHeaderClass: 'fixed',
          tableBodyClass: 'vuetable-semantic-no-top fixed',
          tableClass: '',
          loadingClass: 'loading',
          ascendingIcon: 'fa fa-chevron-up',
          descendingIcon: 'fa fa-chevron-down',
          ascendingClass: 'sorted-asc',
          descendingClass: 'sorted-desc',
          sortableIcon: 'fa fa-sort',
          handleIcon: 'grey sidebar icon',
        },

        paginationInfo: {
          infoClass: '',
        }
      },
      isVisibleDropDownReport: null,
      isVisibleDropDownActions: null
    };
  },
  computed: {
    activeStatusApplicant: function () {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams) return urlParams.get('status_id');
    },
    activeStatusRole: function () {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams) return urlParams.get('status_id');
    }
  },
  watch: {
    perPage: function (val, oldVal) {
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh()

      });
    },
  },
  methods: {
    onCellClicked(data, field, event) {
      if (this.use_detail_row) {
        this.$refs.vuetable.toggleDetailRow(data.id);
      }
    },
    showBulk() {
      if (
        this.view_history_url ||
        this.bulkedit_url ||
        this.bulkcreate_url ||
        this.bulkdelete_url ||
        this.bulkarchive_url ||
        this.exportxls_url ||
        this.exportxls_organizational_units_url ||
        this.exportxls_organizational_units_url ||
        this.sendmail_url ||
        this.resetpassword_url ||
        this.massive_chage_permissions_url ||
        this.clone_models_url ||
        this.copy_models_url ||
        this.make_zip_url ||
        this.make_zip_url_async ||
        (this.bulk_custom_actions != [] && this.bulk_custom_actions.length > 0)
      ) {
        return true;
      }
      return false;
    },
    getFilterFields() {
      if (typeof this.filter_fields === 'string') {
        return JSON.parse(this.filter_fields);
      }
      return this.filter_fields;
    },
    openCoulmnsSelector() {
      app.__vue__.$refs.vue_popup.toggle("Imposta colonne opzionali", this.columnsSelectorUrl);
    },
    handleRightScrollTable() {
      $(".scrollableForVuetable").each(function (index, currentElement) {
        const el = $(currentElement);
        let amount = el.scrollLeft();
        el.animate({ scrollLeft: (amount += 300) });
      });
    },
    handleLeftScrollTable() {
      $(".scrollableForVuetable").each(function (index, currentElement) {
        const el = $(currentElement);
        let amount = el.scrollLeft();
        el.animate({ scrollLeft: (amount -= 300) });
      });
    },
    hasButton(button) {
      let buttonVisible = false;
      for (let i = 0; i < this.default_actions_configuration.length; i++) {
        let buttonConfiguration = this.default_actions_configuration[i];
        if (buttonConfiguration.name == button) {
          buttonVisible = true;
          if (
            buttonConfiguration.visible != undefined &&
            buttonConfiguration.visible != null
          ) {
            buttonVisible = buttonConfiguration.visible;
          }
        }
      }
      return buttonVisible;
    },
    handleAction(button, rowData, index) {
      
      //Defualt Actions
      for (let i = 0; i < this.default_actions_configuration.length; i++) {
        let buttonConfiguration = this.default_actions_configuration[i];
        this.excueteAction(buttonConfiguration, button, rowData);
      }

      //Custom Actions
      if (this.custom_row_actions_configuration != null) {
        for (let i = 0; i < this.custom_row_actions_configuration.length; i++) {
          let buttonConfiguration = this.custom_row_actions_configuration[i];
          this.excueteAction(buttonConfiguration, button, rowData);
        }
      }

    },

    excueteAction(buttonConfiguration, button, rowData) {

        if (buttonConfiguration.name == button) {
    
          if (buttonConfiguration.actionType == "load_component") {
            this.actionLoadComponent(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "popup") {
            this.actionPopup(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "sidebar") {
            this.actionSidebar(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "url") {
            this.actionUrl(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "tab") {
            this.actionTab(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "delete") {
            this.actionDelete(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "deletePivot") {
            this.actionDeletePivot(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "print") {
            this.actionPrint(buttonConfiguration, rowData);
          }
          if (buttonConfiguration.actionType == "livewire_modal") {
            this.actionLivewireModal(buttonConfiguration, rowData);
          }
        }
    },

    actionLoadComponent(buttonConfiguration, item) {
      let component_reference = buttonConfiguration.component.reference;
      if (component_reference.startsWith("component_")) {
        component_reference = component_reference.replace(
          "[component_id]",
          item.question_id
        );
      }
      eval("app.__vue__.$refs." + eval("component_reference")).toggle(
        decodeURI(buttonConfiguration.action).replace("[id]", item.id),
        item.id,
        true,
        buttonConfiguration.component
      );
    },
    actionPopup(buttonConfiguration, item) {
      /* console.log(buttonConfiguration, item.kpi_name); */
      app.__vue__.$refs.vue_popup.toggle(
        buttonConfiguration.popupTitle || item.kpi_name || this.__("misc.Detail"),
        decodeURI(buttonConfiguration.action).replace("[id]", item.id)
      );
    },
    actionSidebar(buttonConfiguration, item) {
      if (buttonConfiguration.name == "edit") {
        var params = { itemId: item.id };
        var params = this.prepareDataVueTableOptions(params);

        this.setVueTableOptions(params);
      }
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(buttonConfiguration.action).replace("[id]", item.id)
      );
    },
    actionUrl(buttonConfiguration, item) {
      location.href = decodeURI(buttonConfiguration.action).replace(
        "[id]",
        item.id
      );
    },
    actionTab(buttonConfiguration, item) {
      window.open(
        decodeURI(buttonConfiguration.action).replace("[id]", item.id),
        "_blank"
      );
    },
    actionDelete(buttonConfiguration, item) {
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete(
                decodeURI(buttonConfiguration.action).replace("[id]", item.id)
              )
              .then((data) => {
                location.reload();
              })
              .catch((error) => {
                if (error.response.status == 405) {
                  Vue.swal.fire({
                    title: error.response.data.advice.title,
                    html: error.response.data.advice.html,
                    icon: "error",
                  });
                } else if (error.response.status == 403) {
                  Vue.swal.fire({
                    title: error.response.data.advice.title,
                    html: error.response.data.advice.html,
                    icon: "warning",
                  });
                } else {
                  location.reload();
                }
              });
          }
        });
    },
    actionDeletePivot(buttonConfiguration, item) {
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            let action = decodeURI(buttonConfiguration.action);
            action +=
              "?" + buttonConfiguration.parameter_name + "=" + item.pivot.id;
            axios.delete(action).then(() => location.reload());
          }
        });
    },
    actionPrint(buttonConfiguration, item) {
      var url = decodeURI(buttonConfiguration.action).replace("[id]", item.id);
      window.open(decodeURI(url), "_blank");
    },
    actionLivewireModal(buttonConfiguration, item) {    
      window.livewire.emit('openModal' + buttonConfiguration.modal_id, {
        'stringParams': '',
        'itemsSelected': item
      });  
      $('#' + buttonConfiguration.modal_id).modal('show');
    },
    onLoading() {
      if (app.__vue__ != undefined) {
        app.__vue__.appendLoader();
      }
    },
    onLoadSuccess(datas) {
      this.renderedItems = datas.data.data;
      if (!this.alreadyRefresh) {
        this.getVueTableOptions();
      } else {
        this.alreadyRefresh = false;
        app.__vue__.removeLoader();
      }
      if (this.fromGoToPage) {
        this.alreadyRefresh = true;
        this.fromGoToPage = false;
        this.$refs.vuetable.gotoPage(this.actualPage);
      }

      if (this.after_on_load_success_trigger_components.length > 0) {
        //Refresh components with filter params
        let filterParams = this.moreParams;
        $.each(
          this.after_on_load_success_trigger_components,
          function (index, refComponent) {
            //if component is not passed to vueTable, or not implements "refreshData" method, raise error for devs
            if (
              refComponent in app.__vue__.$refs &&
              app.__vue__.$refs[refComponent].refreshData != null
            ) {
              app.__vue__.$refs[refComponent].refreshData(
                datas.data.path,
                filterParams
              );
            } else {
              console.error("Component " + refComponent + " Not found");
            }
          }
        );
      }

      $('[data-toggle="tooltip"]').tooltip();
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.actualPage = page;
      this.$refs.vuetable.changePage(page);
      var params = { page: page };
      this.alreadyRefresh = true;
      params = this.prepareDataVueTableOptions(params);
      this.setVueTableOptions(params);
    },
    onCheckboxToggled(checked, item) {
      if (checked) this.itemsSelected.push(item);
      if (!checked)
        this.itemsSelected = this.itemsSelected.filter((x) => x.id !== item.id);
    },
    onCheckboxToggledAll(checked) {
      if (checked) {
        this.itemsSelected = this.renderedItems;
      } else {
        this.itemsSelected = [];
      }
    },
    onDoFilter(filterText) {
      this.alreadyRefresh = true;
      var params = this.prepareDataVueTableOptions();
      this.setVueTableOptions(params);

      this.moreParams = {
        filter: filterText,
        filter_by: this.$refs.filterBar.$refs.filterSelected.value,
      };
      try {
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      } catch (error) {
        console.log(error);
      }
    },
    onResetFilter() {
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : this.$moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatDateTime(value, fmt = "D MMM YYYY HH:mm") {
      return value == null
        ? ""
        : this.$moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    bulkEdit() {
      if (this.itemsSelected.length == 0) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one item",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      let items = this.itemsSelected
        .map(function (item) {
          return "&item_id[]=" + item.id;
        })
        .join("");
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(this.bulkedit_url + "?parms=start" + items)
      );
    },
    bulkCreate() {
      if (this.itemsSelected.length == 0) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one item",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      let items = this.itemsSelected
        .map(function (item) {
          return "&item_id[]=" + item.id;
        })
        .join("");
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(this.bulkcreate_url + "?parms=start" + items)
      );
    },
    bulkDelete() {
      app.__vue__.actionBulkDelete(this.bulkdelete_url, this.itemsSelected);
    },
    viewHistoryLog() {
      if (this.itemsSelected.length == 0 || this.itemsSelected.length > 1) {
        Vue.swal.fire({
          title: "Attenzione",
          text: "Selezionare un record per vederne in log",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      let item = this.itemsSelected[0].id;
      let url = this.view_history_url + "\\" + item;
      app.__vue__.$refs.vue_sidebar.toggle(url);
    },
    bulkArchive() {
      app.__vue__.actionBulkArchive(this.bulkarchive_url, this.itemsSelected);
    },
    updatePermissions() {
      let items =
        app.__vue__.$refs.permission_presets_index_vuetable.$data.itemsSelected;
      let item_ids = items.map(function (item) {
        return item.id;
      });
      if (item_ids.length < 1) {
        Vue.swal.fire({
          title: "No row selected",
          text: "Select one row",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      }

      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(
          this.massive_chage_permissions_url +
          "?permission_preset=" +
          item_ids[0]
        )
      );
    },
    sendEmail(email_type) {
      let items = app.__vue__.$refs.people_index_vuetable.$data.itemsSelected;
      let item_ids = items.map(function (item) {
        return item.id;
      });

      let idsStrings = "";
      for (let i = 0; i < item_ids.length; i++) {
        idsStrings += "id[]=" + item_ids[i] + "&";
      }
      idsStrings = idsStrings.substring(0, idsStrings.length - 1);

      if (item_ids.length < 1) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one item",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      }
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(
          this.sendmail_url + "?email_type=" + email_type + "&" + idsStrings
        )
      );
    },
    massiveEmail() {
      if (this.itemsSelected.length == 0) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one item",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      let items = this.itemsSelected
        .map(function (item) {
          return "&item_id[]=" + item.id;
        })
        .join("");
      app.__vue__.$refs.vue_popup.toggle(
        "",
        decodeURI(this.send_massive_mail_url + "?params=start" + items)
      );
    },
    makeZip(async) {
      let items = this.itemsSelected;
      let item_ids = items.map(function (item) {
        return item.id;
      });

      let idsStrings = "";
      for (let i = 0; i < item_ids.length; i++) {
        idsStrings += "elements[]=" + item_ids[i] + "&";
      }
      idsStrings = idsStrings.substring(0, idsStrings.length - 1);

      if (item_ids.length < 1) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one items",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      } else if (item_ids.length > 100) {
          Vue.swal.fire({
            title: "Too many selected elements",
            text: "You can select a maximum of 100 items.",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
        });
        return false;
      }
      if (async === true) {
        idsStrings += "&async=true";
        app.__vue__.$refs.vue_sidebar.toggle(
          decodeURI(this.make_zip_url_async + "?" + idsStrings)
        );
      } else {
        app.__vue__.$refs.vue_sidebar.toggle(
          decodeURI(this.make_zip_url + "?" + idsStrings)
        );
      }
    },
    executeBulkCustom(bulk_action) {

      let checkLengthItems = (bulk_action.checkLengthItems === undefined) ? true : bulk_action.checkLengthItems;
      let isDisabledButton = (bulk_action.isDisabled === undefined) ? false : bulk_action.isDisabled;
      let items = this.itemsSelected;

      if (isDisabledButton) {
        Vue.swal.fire({
          title: "",
          text: bulk_action.disabledMessage,
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      }
      if (checkLengthItems && items.length < 1) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one items",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      }

      //LimitItems ( eg at least 2 items... )
      if (bulk_action.itemLimits !== undefined && items.length > 0 && items.length > bulk_action.itemLimits) {
        Vue.swal.fire({
          title: "Item limits exceeded",
          text: "You can chose at least " + bulk_action.itemLimits + " element/s",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      }

      //End Controls
      //Mapping Params

      let stringParams = "";

      if (
        bulk_action.paramsItem !== undefined &&
        bulk_action.paramsItem.length > 0
      ) {
        items.map(
          function (item) {
            for (let i = 0; i < bulk_action.paramsItem.length; i++) {
              let param = bulk_action.paramsItem[i];
              let value = item[bulk_action.paramsItem[i]];
              stringParams += param + "[]=" + value + "&";
            }
          },
          bulk_action.paramsItem,
          stringParams
        );
        stringParams = stringParams.substring(0, stringParams.length - 1);
      }

      if (bulk_action.askConfirm) {
        Vue.swal
          .fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
          })
          .then((result) => {
            if (result.value) {
              this.execCustomActionMethod(bulk_action, stringParams);
            }
          });
      } else {
        this.execCustomActionMethod(bulk_action, stringParams);
      }
    },
    execCustomActionMethod(bulk_action, stringParams) {

      switch (bulk_action.method) {
        case 'get':
          this.execCustomActionGetAxios(bulk_action, stringParams);
          break;
        case "post":
          this.execCustomActionPostAxios(bulk_action, stringParams);
          break;
        case "url":
          let items = this.itemsSelected.map(function (item) {
            return "&item_id[]=" + item.id;
          }).join("");
          if (items.length > 0) {
            window.location.href = bulk_action.url + "?" + items;
          } else {
            window.location.href = bulk_action.url + items;
          }
          break;
        case "vuesidebar":
          app.__vue__.$refs.vue_sidebar.toggle(
            bulk_action.url + "?" + stringParams
          );
          break;
        case 'vuepopup':
          app.__vue__.$refs.vue_popup.toggle('', bulk_action.url + "?" + stringParams);
          break;
        case 'livewire_modal':
          this.execCustomActionLivewireModal(bulk_action, stringParams);
          break;

        default:
          window.location.href = bulk_action.url;
          break;
      }
    },
    execCustomActionLivewireModal(bulk_action, stringParams) {

      let errorTxt = "";
      if (bulk_action.modalId === undefined) {
        errorTxt += "You must define \'modalId\' field ";
      }
      if ($('#' + bulk_action.modalId).length === 0) {
        errorTxt += "Modal \'" + bulk_action.modalId + "\'  not found in view ";
      }
      if (errorTxt.length > 0) {
        Vue.swal.fire({
          title: "Wrong settings",
          text: errorTxt,
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      window.livewire.emit('openModal' + bulk_action.modalId, {
        'stringParams': stringParams,
        'itemsSelected': this.itemsSelected
      }
      );
      $('#' + bulk_action.modalId).modal('show');
    },
    execCustomActionPostAxios(bulk_action, stringParams) {
      axios
        .post(bulk_action.url + "?" + stringParams)
        .then((response) => {
          Vue.$toast.open({
            message: "Operation completed",
            type: "success",
            position: "top-right",
          });
          window.location.reload();
        })
        .catch((error) => {
          Vue.$toast.open({
            message: error,
            type: "error",
            icon: "warning",
            position: "top-left",
          });
        });
    },
    execCustomActionGetAxios(bulk_action, stringParams) {
      axios
        .get(bulk_action.url + "?" + stringParams)
        .then((response) => {
          Vue.$toast.open({
            message: "Operation completed",
            type: "success",
            position: "top-right",
          });
          window.location.reload();
        })
        .catch((error) => {
          Vue.$toast.open({
            message: error,
            type: "error",
            icon: "warning",
            position: "top-left",
          });
        });
    },
    cloneElement() {
      let items = this.itemsSelected
        .map(function (item) {
          return "&item_id[]=" + item.id;
        })
        .join("");
      if (items.length < 1) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one item",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return false;
      }
      axios
        .post(this.clone_models_url + "?" + items)
        .then((response) => {
          Vue.swal
            .fire({
              title: "Elementi clonati",
              text: "",
            })
            .then((result) => {
              if (result.value) {
                window.location.href = this.clone_models_redirect;
              }
            });
        })
        .catch(function (error) {
          alert(error);
        });
    },
    copyElement() {
      if (this.itemsSelected.length == 0) {
        Vue.swal.fire({
          title: "No items selected",
          text: "Select at least one item",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        });
        return;
      }
      let items = this.itemsSelected
        .map(function (item) {
          return "item_id[]=" + item.id;
        })
        .join("");
      app.__vue__.$refs.vue_sidebar.toggle(
        decodeURI(this.copy_models_url + "?" + items)
      );
    },
    prepareDataVueTableOptions(params = {}) {
      params = params == null ? {} : params;
      return {
        ref: params.ref !== undefined ? params.ref : this.$vnode.data.ref,
        filter:
          params.filter !== undefined
            ? params.filter
            : this.$refs.filterBar.filterText,
        filter_by:
          params.filter_by !== undefined
            ? params.filter_by
            : this.$refs.filterBar.$refs.filterSelected.value,
        page: params.page !== undefined ? params.page : this.actualPage,
        item_id:
          params.itemId !== undefined ? params.itemId : this.actualItemId,
        already_refresh:
          params.already_refresh !== undefined
            ? params.already_refresh
            : this.alreadyRefresh,
      };
    },
    setVueTableOptions(params) {
      params.ref = this.$vnode.data.ref;
      app.__vue__.setVueTableOptions(params);
    },
    getVueTableOptions() {
      var thisVue = this;
      var ref = this.$vnode.data.ref;

      if (this.fromGoToPage) {
        return;
      }

      axios
        .get("/get-vue-table-options?ref=" + ref)
        .then((response) => {
          if (response.data == null) {
            app.__vue__.removeLoader();
            return;
          }

          if (response.data.filter != null && response.data.filter != "") {
            thisVue.setFilterBySessionOption(thisVue, response.data);
          } else {
            thisVue.setPageBySessionOption(thisVue, response.data);
          }

          thisVue.setItemIdBySessionOption(thisVue, response.data);
        })
        .catch((error) => {
          console.log(error);
          app.__vue__.removeLoader();
        });
    },
    setFilterBySessionOption(thisVue, data) {
      if (data.filter != null && data.filter != "") {
        thisVue.moreParams = {
          filter: data.filter,
          filter_by: data.filter_by,
        };
        thisVue.$refs.filterBar.filterText = data.filter;
        thisVue.$refs.filterBar.select1 = data.filter_by;

        thisVue.alreadyRefresh = true;
        this.fromGoToPage = true;
        this.actualPage = data.page;
        try {
          Vue.nextTick(() => thisVue.$refs.vuetable.refresh());
          eval(thisVue.filter_callback.function)(thisVue.renderedItems);
        } catch (error) {
          console.log(error);
        }
      }
    },
    setPageBySessionOption(thisVue, data) {
      if (data.page != null && data.page != thisVue.actualPage) {
        thisVue.actualPage = data.page;
        thisVue.$refs.vuetable.changePage(data.page);
      }
      app.__vue__.removeLoader();
    },
    setItemIdBySessionOption(thisVue, data) {
      if (data.itemId != null) {
        thisVue.actualItemId = data.itemId;
        var action = null;
        for (var i = 0; i < thisVue.default_actions_configuration.length; i++) {
          if (thisVue.default_actions_configuration[i].name == "edit") {
            action = thisVue.default_actions_configuration[i].action;
          }
        }
        app.__vue__.$refs.vue_sidebar.toggle(
          decodeURI(action).replace("[id]", data.itemId)
        );
      }
    },
    openAdvancedFilters() {
      $('#advancedFilterModal').modal('toggle');
    },
    setPagination(perPage) {
      this.perPage = perPage;
    },
    refreshTableFromOutside() {
      this.$refs.vuetable.refresh()
    },
    getVisibleDropDownActions() {
      let visible =
        this.view_history_url ||
        this.bulkedit_url ||
        this.bulkcreate_url ||
        this.bulkdelete_url ||
        this.bulkarchive_url ||
        this.sendmail_url ||
        this.send_massive_mail_url ||
        this.resetpassword_url ||
        this.massive_chage_permissions_url ||
        this.clone_models_url ||
        this.copy_models_url ||
        this.copy_models_url ||
        (this.bulk_custom_actions != null && this.bulk_custom_actions.length > 0);

      return visible;
    },
    getVisibleDropDownReport() {
      let visible = this.exportxls_url ||
        this.exportxls_organizational_units_url ||
        this.make_zip_url ||
        this.make_zip_url_async ||
        (this.report_actions != null && this.report_actions.length > 0);

      return visible;
    },
    isVisibleCustomRowActions(){
      return this.custom_row_actions_configuration != null && this.custom_row_actions_configuration.length > 0
    },
    getCustomRowActionsConfiguration(rowData){

      let result = [];

      if (this.custom_row_actions_configuration == null){
        return result;
      }

      if (this.custom_row_actions_configuration.length == 0){
        return result;
      }

      for(let i = 0; i < this.custom_row_actions_configuration.length; i++){

        let rowAction = this.custom_row_actions_configuration[i];

        if (rowAction.visible != true){
          continue;
        }

        if (rowAction.conditionField === undefined || rowAction.conditionField == null) {
          result.push(rowAction);
          continue;
        }

        if (rowData[rowAction.conditionField]){
          result.push(rowAction);
        }
      }
      
      return result;
    },
    checkCustomRowConditionFieldVisibility(rowData, rowAction){
      return false;
    }
  },
  props: {
    applicant_filters: {
      required: false,
    },
    roles_filters: {
      required: false,
    },
    collapse_mbo: {
      type: Boolean,
      required: false,
    },
    collapse_kpi: {
      type: Boolean,
      required: false,
    },
    component_filters_name: {
      type: String,
      required: false,
    },
    vtbl_url: {
      type: String,
      required: true,
    },
    vtbl_fields: {
      type: Array,
      required: true,
    },
    vtbl_sort_order: {
      type: Array,
      required: false,
      default: () => [
        {
          field: "id",
          direction: "desc",
        },
      ],
    },
    vtbl_columns_selector: {
      type: String,
      required: false,
    },
    use_detail_row: {
      type: Boolean,
      required: false,
      default: false,
    },
    exportxls_url: {
      type: String,
      required: false,
    },
    exportxls_organizational_units_url: {
      type: String,
      required: false,
    },
    make_zip_url: {
      type: String,
      required: false,
    },
    make_zip_url_async: {
      type: String,
      required: false,
    },
    sendmail_url: {
      type: String,
      required: false,
    },
    send_massive_mail_url: {
      type: String,
      required: false,
    },
    massive_chage_permissions_url: {
      type: String,
      required: false,
    },
    clone_models_url: {
      type: String,
      required: false,
    },
    clone_models_redirect: {
      type: String,
      required: false,
    },
    after_on_load_success_trigger_components: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    copy_models_url: {
      type: String,
      required: false,
    },
    resetpassword_url: {
      type: String,
      required: false,
    },
    bulkdelete_url: {
      type: String,
      required: false,
    },
    bulkarchive_url: {
      type: String,
      required: false,
    },
    bulkedit_url: {
      type: String,
      required: false,
    },
    bulkcreate_url: {
      type: String,
      required: false,
    },
    view_history_url: {
      type: String,
      required: false,
    },
    vtbl_show_search: {
      type: Boolean,
      required: false,
      default: true,
    },
    vtbl_show_bulk: {
      type: Boolean,
      required: false,
      default: true,
    },
    vtbl_show_paginator: {
      type: Boolean,
      required: false,
      default: true,
    },
    filter_fields: {
      type: Array,
      required: false
    },
    default_actions_configuration: {
      type: Array,
      default: () => [
        {
          name: "edit",
          action: location.href + "/[id]/edit",
          actionType: "url",
        },
        {
          name: "delete",
          action: location.href + "/[id]",
          actionType: "delete",
        },
      ],
    },
    filter_callback: {
      type: Object,
      required: false,
    },
    bulk_custom_actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    report_actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    has_advanced_filters: {
      required: false,
      default: false
    },
    detail_row_component:{
      type: String,
      required: false,
      default: ''
    },
    custom_row_actions_configuration: {
      type: Array,
      required: false
    }
  },
};
</script>

<style lang="scss">


.dropdown-menu-left {
  right: auto;
  left: 0;
}

/* new table */

.newtable-container {

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-track {
    background: white;
    border-radius: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: #1767a2;
    border-radius: 0px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #559bd9;
    border-radius: 0px;
  }

  max-height: 68vh;
  overflow-y: scroll;
  width: 100%;
  border-radius:10px;
  margin-top:10px;

  >table {
    overflow-y: scroll;
    table-layout: fixed;
    table-layout: auto;
    width: 100%;

    thead tr th,
    tbody tr td {
      font-size: 13px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      height: 40px;
      padding: 8px 18px 8px;
    }

    thead tr th {
    vertical-align: middle;
    background: #1767a2;
    color: white;
    font-weight: 500;
    font-family: 'Circular STD', sans-serif;
    position: sticky;
    top: 0;
    z-index: 1;

      &:hover {
        background: #559bd9;
        color: white !important;
      }
    }

    tbody tr td {
      vertical-align: middle;

      a {
        text-decoration: underline;
        color: #1B6297;
      }

      a,
      span {
        display: flex;
        align-items: center;

        img {
          width: 32px;
          height: 32px;
          display: inline;
          margin-right: 4px;
        }

        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    table.internal-detail-table {
      width: 100%;

      thead {
        position: relative;
        z-index: 0;
      }

      thead tr th,
      tbody tr td {
        height: 30px;
      }

      thead tr th {
        background: #1F8EDE;
        border:none;
      }
    }
  }
}

.vuetable-th-checkbox-id.center.aligned,
.vuetable-checkboxes.center.aligned {
  width: 60px !important;
  min-width: 60px !important;

  input[type=checkbox] {
    width: 15px;
    height: 15px;
  }
}


div.filter-bar-table {
  margin-bottom: -10px !Important;
  margin-left: 10px !important;
  margin-right: 10px !important;
  box-shadow: 3px 3px #DFE6F6 !important;
  border-radius: 10px !important;
}

div.table-rounded-buttons {
  margin-top: 5px !important;
}

.actions-cell button{
  margin-left: 4px;
}

.custom-description-class {
  width:50px !important;
}
</style>

